import * as React from 'react';

import { useOfferContext } from '../../../context';
import {
  getBalcony,
  getBuildingDeadline,
  getBuildingStatus,
  getLeasePeriod,
  getMaterialType,
  getLandType,
  getLift,
  isSuburban,
  isRent,
  isResidential,
  isCommercial,
  getOfferLayout,
  getAccessType,
} from '../../../utils/offers';
import { Type } from 'shared/components/OfferCard/Type';

export const OfferTypeContainer = () => {
  const { offer } = useOfferContext();

  const { category, building, loggiasCount, balconiesCount } = offer;

  const texts = React.useMemo(() => {
    const types: (string | null | undefined)[] = [getLeasePeriod(offer)];

    // Коммерческая
    if (isCommercial(offer.offerType ?? undefined)) {
      types.push(getAccessType(offer), getOfferLayout(offer));
    }

    // Загородная
    if (isSuburban(offer.category)) {
      types.push(getLandType(offer.land ?? undefined));
    }

    // Жилая продажа
    if (
      !isRent(offer.dealType ?? undefined) &&
      !isSuburban(offer.category) &&
      !isCommercial(offer.offerType ?? undefined)
    ) {
      types.push(
        getMaterialType(offer.building ?? undefined),
        getBuildingStatus(offer.category),
        getBuildingDeadline(offer.building ?? undefined),
      );
    }

    // Жилая аренда и продажа
    if (isResidential(category) && !isSuburban(category) && !isCommercial(offer.offerType ?? undefined)) {
      types.push(
        getBalcony({ loggiasCount: loggiasCount ?? undefined, balconiesCount: balconiesCount ?? undefined }),
        getLift(building ?? undefined),
      );
    }

    return types.filter(Boolean).map((type, index, arr) => `${type}${index === arr.length - 1 ? '' : ',\u00A0'}`);
  }, [balconiesCount, building, category, loggiasCount, offer]);

  return <Type texts={texts} />;
};
